module.exports = __webpack_public_path__ + "static/snake_tree_leafs_ao-7c1c4266703a4d6ba9a1ed179cabddaa.jpg";